export class ListDataSource {
  ColumnInfos: ColumnInfo[];
  Data: any;
  IsDynamic?: boolean;
  constructor(data: any) {
    Object.assign(this, data);
  }
}

export class ColumnInfo {
  Name: string;
  Caption: string;
}

export class ActionsAndInfoDetails {
  InsertOn: string;
  InsertAt: string;
  InsertBy: string;
  UpdateOn: string;
  UpdateAt: string;
  UpdateBy: string;
  Properties: number;
  Documents: number;
  Comments: number;
  constructor(data?: any) {
    Object.assign(this, data);
  }
}

export class ArenaUser {
  displayText: string;
  imgPortrait: string;
}
